// The Video.js 10 default skin's icons: SVG path data on an 18-unit grid, y downwards, in layers (some
// are half-opaque, and a few are outlines). Native full-screen draws the same data from its own copy,
// generated from @videojs/html, so the two change together: regenerate rather than edit. `language` is
// the exception: the Heroicons glyph the app uses for choosing a language.

export type IconLayer = { path: string; alpha: number; strokeWidth: number };

export const ICON_GRID = 18;

export const PLAYER_ICONS = {
    play: [
        {
            path: "m14.051 10.723-7.985 4.964a1.98 1.98 0 0 1-2.758-.638A2.06 2.06 0 0 1 3 13.964V4.036C3 2.91 3.895 2 5 2c.377 0 .747.109 1.066.313l7.985 4.964a2.057 2.057 0 0 1 .627 2.808c-.16.257-.373.475-.627.637",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    pause: [
        {
            path: "M3.75 2h1.5a1.75 1.75 0 0 1 1.75 1.75v10.5a1.75 1.75 0 0 1 -1.75 1.75h-1.5a1.75 1.75 0 0 1 -1.75 -1.75v-10.5a1.75 1.75 0 0 1 1.75 -1.75z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
        {
            path: "M12.75 2h1.5a1.75 1.75 0 0 1 1.75 1.75v10.5a1.75 1.75 0 0 1 -1.75 1.75h-1.5a1.75 1.75 0 0 1 -1.75 -1.75v-10.5a1.75 1.75 0 0 1 1.75 -1.75z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    volumeOff: [
        {
            path: "M.714 6.008h3.072l4.071-3.857c.5-.376 1.143 0 1.143.601V15.28c0 .602-.643.903-1.143.602l-4.071-3.858H.714c-.428 0-.714-.3-.714-.752V6.76c0-.451.286-.752.714-.752M14.5 7.586l-1.768-1.768a1 1 0 1 0-1.414 1.414L13.085 9l-1.767 1.768a1 1 0 0 0 1.414 1.414l1.768-1.768 1.768 1.768a1 1 0 0 0 1.414-1.414L15.914 9l1.768-1.768a1 1 0 0 0-1.414-1.414z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    volumeLow: [
        {
            path: "M.714 6.008h3.072l4.071-3.857c.5-.376 1.143 0 1.143.601V15.28c0 .602-.643.903-1.143.602l-4.071-3.858H.714c-.428 0-.714-.3-.714-.752V6.76c0-.451.286-.752.714-.752m10.568.59a.91.91 0 0 1 0-1.316.91.91 0 0 1 1.316 0c1.203 1.203 1.47 2.216 1.522 3.208q.012.255.011.51c0 1.16-.358 2.733-1.533 3.803a.7.7 0 0 1-.298.156c-.382.106-.873-.011-1.018-.156a.91.91 0 0 1 0-1.316c.57-.57.995-1.551.995-2.487 0-.944-.26-1.667-.995-2.402",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    volumeHigh: [
        {
            path: "M15.6 3.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4C15.4 5.9 16 7.4 16 9s-.6 3.1-1.8 4.3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.3 0 .5-.1.7-.3C17.1 13.2 18 11.2 18 9s-.9-4.2-2.4-5.7",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
        {
            path: "M.714 6.008h3.072l4.071-3.857c.5-.376 1.143 0 1.143.601V15.28c0 .602-.643.903-1.143.602l-4.071-3.858H.714c-.428 0-.714-.3-.714-.752V6.76c0-.451.286-.752.714-.752m10.568.59a.91.91 0 0 1 0-1.316.91.91 0 0 1 1.316 0c1.203 1.203 1.47 2.216 1.522 3.208q.012.255.011.51c0 1.16-.358 2.733-1.533 3.803a.7.7 0 0 1-.298.156c-.382.106-.873-.011-1.018-.156a.91.91 0 0 1 0-1.316c.57-.57.995-1.551.995-2.487 0-.944-.26-1.667-.995-2.402",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    quality: [
        {
            path: "M12.5 9.5a3.5 3.5 0 1 1 0 7h-7a3.5 3.5 0 1 1 0-7zm-2 1.5a2 2 0 1 0 0 4h2a2 2 0 1 0 0-4z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
        {
            path: "M12.5 1.5a3.5 3.5 0 1 1 0 7h-7a3.5 3.5 0 1 1 0-7zM5.5 3a2 2 0 1 0 0 4h2a2 2 0 1 0 0-4z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
    ],
    language: [
        {
            path: "m7.875 15.75 3.938-8.438L15.75 15.75m-6.75-2.25h5.625M2.25 4.216a36.355 36.355 0 0 1 4.5-.278m0 0c.84 0 1.675.028 2.501.086M6.75 3.938V2.25m2.501 1.773C8.382 7.993 5.768 11.31 2.25 13.127m7-9.104c.672.046 1.339.11 1.999.193m-3.442 6.371a13.517 13.517 0 0 1-2.87-4.351",
            alpha: 1.0,
            strokeWidth: 1.125,
        },
    ],
    speed: [
        {
            path: "M9 18q-.213 0-.424-.012h.85Q9.214 18 9 18M9 2a8 8 0 0 1 8 8c0 1.975-.719 3.78-1.905 5.175a.75.75 0 0 1-1.204.018l-1.509-1.971a.75.75 0 0 1 .596-1.206h1.674a6 6 0 1 0-11.304 0h1.68a.75.75 0 0 1 .596 1.206l-1.507 1.971a.75.75 0 0 1-1.133.07l-.003.004A8 8 0 0 1 9 2",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
        {
            path: "M7 14h4a1 1 0 0 1 1 1v0a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v0a1 1 0 0 1 1 -1z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
        {
            path: "M8.3 6.318c.246-.64 1.154-.64 1.4 0L10.732 9h-.002a2 2 0 1 1-3.46 0h-.001z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
        {
            path: "M4.25 10.25a.75 .75 0 1 0 1.5 0a.75 .75 0 1 0 -1.5 0z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
        {
            path: "M12.25 10.25a.75 .75 0 1 0 1.5 0a.75 .75 0 1 0 -1.5 0z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
        {
            path: "M5.25 7.25a.75 .75 0 1 0 1.5 0a.75 .75 0 1 0 -1.5 0z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
        {
            path: "M11.25 7.25a.75 .75 0 1 0 1.5 0a.75 .75 0 1 0 -1.5 0z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
    ],
    captions: [
        {
            path: "M4 3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3z",
            alpha: 1.0,
            strokeWidth: 2.0,
        },
        {
            path: "M4 8h1a1 1 0 0 1 1 1v0a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v0a1 1 0 0 1 1 -1z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
        {
            path: "M14 8h0a1 1 0 0 1 1 1v0a1 1 0 0 1 -1 1h0a1 1 0 0 1 -1 -1v0a1 1 0 0 1 1 -1z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
        {
            path: "M12 11h2a1 1 0 0 1 1 1v0a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v0a1 1 0 0 1 1 -1z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
        {
            path: "M8 8h3a1 1 0 0 1 1 1v0a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v0a1 1 0 0 1 1 -1z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
        {
            path: "M4 11h5a1 1 0 0 1 1 1v0a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v0a1 1 0 0 1 1 -1z",
            alpha: 0.5,
            strokeWidth: 0.0,
        },
    ],
    cast: [
        {
            path: "M14.5 2A3.5 3.5 0 0 1 18 5.5v7l-.005.18a3.5 3.5 0 0 1-3.315 3.315L14.5 16h-7c0-.693-.096-1.363-.271-2H14.5a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 14.5 4h-11A1.5 1.5 0 0 0 2 5.5v3.271A7.5 7.5 0 0 0 0 8.5v-3A3.5 3.5 0 0 1 3.5 2zM0 12a4 4 0 0 1 4 4H2.5A2.5 2.5 0 0 0 0 13.5z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
        {
            path: "M0 9.5A6.5 6.5 0 0 1 6.5 16H5a5 5 0 0 0-5-5zm0 5A1.5 1.5 0 0 1 1.5 16h-1a.5.5 0 0 1-.5-.5z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    pip: [
        {
            path: "M13 2a4 4 0 0 1 4 4v2.036A3.5 3.5 0 0 0 16.5 8H15V6.273C15 5.018 13.96 4 12.679 4H4.32C3.04 4 2 5.018 2 6.273v5.454C2 12.982 3.04 14 4.321 14H6v1.5q0 .255.036.5H4a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
        {
            path: "M10 10h6a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-3a2 2 0 0 1 2 -2z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
        {
            path: "M7.129 5.547a.6.6 0 0 0-.656.13L3.677 8.473A.6.6 0 0 0 4.102 9.5h2.796c.332 0 .602-.27.602-.602V6.103a.6.6 0 0 0-.371-.556",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    fullscreenEnter: [
        {
            path: "M9.57 3.617A1 1 0 0 0 8.646 3H4c-.552 0-1 .449-1 1v4.646a.996.996 0 0 0 1.001 1 1 1 0 0 0 .706-.293l4.647-4.647a1 1 0 0 0 .216-1.089m4.812 4.812a1 1 0 0 0-1.089.217l-4.647 4.647a.998.998 0 0 0 .708 1.706H14c.552 0 1-.449 1-1V9.353a1 1 0 0 0-.618-.924",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    fullscreenExit: [
        {
            path: "M7.883 1.93a.99.99 0 0 0-1.09.217L2.146 6.793A.998.998 0 0 0 2.853 8.5H7.5c.551 0 1-.449 1-1V2.854a1 1 0 0 0-.617-.924m7.263 7.57H10.5c-.551 0-1 .449-1 1v4.646a.996.996 0 0 0 1.001 1.001 1 1 0 0 0 .706-.293l4.646-4.646a.998.998 0 0 0-.707-1.707z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    airplay: [
        {
            path: "M14.5 2A3.5 3.5 0 0 1 18 5.5v5l-.005.18a3.5 3.5 0 0 1-3.027 3.288L13 12h1.5a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 14.5 4h-11A1.5 1.5 0 0 0 2 5.5v5A1.5 1.5 0 0 0 3.5 12H5l-1.968 1.967A3.5 3.5 0 0 1 0 10.5v-5A3.5 3.5 0 0 1 3.5 2z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
        {
            path: "M8.631 10.902a.5.5 0 0 1 .738 0l4.363 4.76a.5.5 0 0 1-.369.838H4.637a.5.5 0 0 1-.369-.838z",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    captionsOn: [
        {
            path: "M15 2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zM4 11a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2zm8 0a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM4 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm4 0a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2zm6 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
            alpha: 1.0,
            strokeWidth: 0.0,
        },
    ],
    check: [{ path: "M4 10.455 6.5 13 14 5", alpha: 1.0, strokeWidth: 2.0 }],
} satisfies Record<string, IconLayer[]>;

export type PlayerIconName = keyof typeof PLAYER_ICONS;
